import generateIcon from './generateIcon';
var CheckSvg = "<svg fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.488 5.431a.75.75 0 01.081 1.058l-10.285 12a.75.75 0 01-1.125.016l-5.714-6.286a.75.75 0 011.11-1.009l5.143 5.657L19.43 5.512a.75.75 0 011.057-.08z\"/></svg>";
export default generateIcon(CheckSvg, {
  name: 'CheckOutlined'
});